export const getTileSize = (vehicles) => {

    if (vehicles >= 200) {

        return {
            colSpan: 3,
            rowSpan: 3
        };
    }

    if (vehicles >= 100) {

        return {
            colSpan: 3,
            rowSpan: 2
        };
    }

    if (vehicles >= 50) {

        return {
            colSpan: 2,
            rowSpan: 2
        };
    }

    if (vehicles >= 20) {

        return {
            colSpan: 2,
            rowSpan: 1
        };
    }

    return {
        colSpan: 1,
        rowSpan: 1
    };
};